import { getPostHogFeatureFlagClient } from "@/shared/lib/monitoring/telemetry-config"

export const FIRST_VALUE_PAYWALL_EXPERIMENT_FLAG = "cro-first-value-paywall-exposure"

export type FirstValuePaywallExperimentVariant =
  | "control"
  | "first_value_prompt"
  | "unassigned"

interface PostHogWithFlags {
  getFeatureFlag: (key: string) => string | boolean | undefined
  onFeatureFlags?: (cb: () => void) => (() => void) | void
}

export function normalizeFirstValuePaywallVariant(
  raw: string | boolean | undefined
): FirstValuePaywallExperimentVariant {
  if (raw === "first_value_prompt") return "first_value_prompt"
  if (raw === "control" || raw === false) return "control"
  return "unassigned"
}

export async function getFirstValuePaywallVariantWhenReady(
  timeoutMs = 1000
): Promise<FirstValuePaywallExperimentVariant> {
  const ph = getPostHogFeatureFlagClient<PostHogWithFlags>()
  if (!ph) return "unassigned"

  const readVariant = () => {
    const raw = ph.getFeatureFlag(FIRST_VALUE_PAYWALL_EXPERIMENT_FLAG)
    return {
      raw,
      variant: normalizeFirstValuePaywallVariant(raw),
    }
  }

  const current = readVariant()
  if (current.raw !== undefined) return current.variant
  if (typeof ph.onFeatureFlags !== "function") return current.variant

  return new Promise((resolve) => {
    let settled = false
    let unsubscribe: (() => void) | void
    const timeout = window.setTimeout(() => {
      if (settled) return
      settled = true
      unsubscribe?.()
      resolve(readVariant().variant)
    }, timeoutMs)

    unsubscribe = ph.onFeatureFlags?.(() => {
      if (settled) return
      settled = true
      window.clearTimeout(timeout)
      unsubscribe?.()
      resolve(readVariant().variant)
    })
  })
}

export function shouldShowFirstValuePaywall(args: {
  isFreeUser: boolean
  isImageIntent: boolean
  successfulTextResponsesBeforeCurrent: number
  variant: FirstValuePaywallExperimentVariant
}): boolean {
  return (
    args.isFreeUser &&
    !args.isImageIntent &&
    args.successfulTextResponsesBeforeCurrent === 0 &&
    args.variant === "first_value_prompt"
  )
}
